<div class="brand-header-wrapper" [ngClass]="{'scrolled': !stateService.isRouterOutletScrolledToTop()}">
  <ag-grid-angular
    class="brand-header-grid messaging-category-grid header"
    style="width: 100%;"
    [rowData]="rowData"
    [columnDefs]="colDefs"
    [modules]="modules"
    [theme]="theme"
    [domLayout]="'autoHeight'"
    [suppressCellFocus]="true"
    [gridOptions]="gridOptions">
  </ag-grid-angular>
</div>

